'use client'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect } from 'react'
import { logger } from '@/utils/logger'

export default function ErrorPage({
  error,
  reset,
}: Readonly<{ error: Error & { digest?: string }; reset: () => void }>) {
  useEffect(() => {
    logger.error('Application error', { error: error.message, digest: error.digest, stack: error.stack })
  }, [error])

  const handleRetry = () => {
    // First try to use Next.js reset function
    reset()
    // As a fallback, refresh the page
    window.location.reload()
  }

  return (
    <section className="errorpage">
      <div className="container">
        <div className="flex min-h-screen flex-col justify-center lg:mx-auto lg:max-w-3xl">
          <div className="mb-4">
            <Image src="/images/sf-logo.svg" alt="Secureframe" width={172} height={24} />
          </div>
          <div className="content">
            <h1 className="text-[calc(2.325rem+.9vw)] tracking-[-1.28px] xl:text-[4rem]">500. Internal Server Error</h1>
            <p className="mb-8 mt-2">
              An error has occurred and we are working to fix the problem. If you need immediate help, please{' '}
              <Link className="contact text-primary-green-150 underline" href="/contact">
                contact us
              </Link>
              .
            </p>

            <button onClick={handleRetry} className="btn btn-default btn-primary">
              Try Again
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
